var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBg2Icon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 319 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#47C2BF",
  d: "M319 .23c0 5-71.411 9.054-159.5 9.054C71.41 9.284 0 5.231 0 .23v26c0-5 71.41-9.053 159.5-9.053 88.089 0 159.5 4.053 159.5 9.054z",
  opacity: 0.6
})));
export default SvgBg2Icon;